import React, { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ErrorModal from '../../components/errorModal';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Label, FormGroup, Input } from 'reactstrap';
import DeleteModal from '../../components/deleteModal';
import Checkbox from '../../components/forms/fields/checkbox';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class CheckSpecificCaseComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,

        };

    }


    componentDidMount() {

    }
    componentDidUpdate(prevProps) {

    }

    toggle = () => {
        if (this.props.toggle) {
            this.props.toggle();
        }
    }
    checkCase = () => {
        const caseNumber = this.state.caseNumber;
        if (!caseNumber) {
            this.setState({ error: 'Please enter case number' });
            return;
        }
        this.setState({ loading: true }, () => {
            fetch(`${API_ENDPOINT}/data/webDocSettings/check-case`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ caseNumber })
            }).then(parseJSON).then(({ result, status }) => {
                if (status === 200) {
                    if (result?.error) {
                        this.setState({ loading: false, error: result.error });
                        return;
                    } else {
                        this.setState({ loading: false, caseData: result });
                    }


                    if (this.props.onUpdate) {
                        this.props.onUpdate();
                    }

                } else {
                    this.setState({ loading: false, error: result.message || result?.error });
                }

            })
        });
    }


    render() {
        const isOpen = this.props.isOpen;

        return (
            <div>
                {
                    this.state.loading ?
                        <div className="whole-screen-loader-wrap">
                            <div className="loader-wrap">
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            isOpen={this.state.error ? true : false}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>
                        : null
                }
                <Modal
                    isOpen={isOpen}
                    toggle={() => this.toggle()}
                    className='connected-group-to-webdoc-preview-modal'
                    centered
                    size="lg"
                >
                    <ModalHeader toggle={() => this.toggle()}>
                        {'Check specific case'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody style={{ paddingTop: 0 }}>
                        <div className='check-specific-case-wrap'>
                            <FormGroup>
                                <Label>{'Case number'}</Label>
                                <Input type="text" value={this.state.caseNumber} onChange={(e) => {
                                    let value = e.target.value?.replace(/\D/g, '');
                                    this.setState({ caseNumber: value });
                                }}
                                />
                            </FormGroup>
                            <Button color='primary' onClick={() => {
                                this.checkCase();
                            }}>
                                {'Check'.translate(this.props.lang)}
                            </Button>
                        </div>

                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>


                        <Button color='primary' onClick={() => {
                            this.toggle();
                        }}>
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}



export default CheckSpecificCaseComponent;
